module.exports = __webpack_public_path__ + "assets/fold-da35cf.svg";